import { apiClient } from "@apis/apiClient";


/* eslint-disable @typescript-eslint/no-explicit-any */
export default {
  search(searchText: any) {
    return apiClient.get(`/rest/global_search?search=${searchText}`);
  },
  getSearchHistory() {
    return apiClient.get(`/rest/search_history`);
  },
};
